import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

/**
 * https://www.neko2me.net/2018/08/angularroutereusestrategy.html
 */
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedHandles: { [path: string]: DetachedRouteHandle } = {};

  /**
   *
   * @param route
   */
  private getPath(route: ActivatedRouteSnapshot) {
    const url = route.pathFromRoot.filter(r => r.url.length > 0).map(r => r.url.map(u => u.path).join('/')).join('/');
    return url.length > 0? url: null;
  }

  /**
   *
   * @param route
   */
  private isReuse(route: ActivatedRouteSnapshot) {
    return route.routeConfig && !route.routeConfig.loadChildren
      && route.routeConfig.data && route.routeConfig.data.reuse;
  }

  /**
   *
   * @param route
   */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isReuse(route);
  }
  /**
   *
   * @param route
   * @param handle
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (this.isReuse(route)) {
      const path = this.getPath(route);
      if (path) {this.storedHandles[path] = handle;}
    }
  }

  /**
   *
   * @param route
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (this.isReuse(route)) {
      const path = this.getPath(route);
      if (path) {return !!this.storedHandles[path];}
    }
    return false;
  }
  /**
   *
   * @param route
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (this.isReuse(route)) {
      const path = this.getPath(route);
      console.log(this.storedHandles);
      if (path) {return this.storedHandles[path] || null;}
    }
    return null;
  }

  /**
   *
   * @param future
   * @param curr
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  /**
   *
   * @param route
   */
  refresh(route: ActivatedRouteSnapshot) {
    const path = this.getPath(route);
    if (path && this.storedHandles[path]) {
      delete this.storedHandles[path];
    }
  }

  /**
   *
   */
  refreshAll() {
    console.log('this.storedHandles', this.storedHandles);
    Object.keys(this.storedHandles).forEach(key => delete this.storedHandles[key]);
    console.log('this.storedHandles inited', this.storedHandles);
  }
}
